<template>
  <div class="flex-col page">
    <div class="flex-col flex-auto group_3 space-y-300">
      <div class="flex-col space-y-14">
        <div class="flex-row justify-between items-center group_4">
          <div class="flex-row space-x-8">
            <div class="shrink-0 section"></div>
            <span class="text_3">自动更新数据</span>
          </div>
          <!-- <van-switch v-model="acSwitch" active-color="#2666DE" inactive-color="#D4E2FD" size="22px" /> -->
        </div>
        <div class="flex-col">
          <div class="flex-row justify-between items-center section_2">
            <span class="font_1">更新时间</span>
            <div class="flex-row items-center space-x-42" @click="showTime = true">
              <span class="text_4">{{ currentTime }}</span>
              <img class="shrink-0 image_5" src="https://codefun-proj-user-res-1256085488.cos.ap-guangzhou.myqcloud.com/64489f9d5a7e3f0310f71776/6461034fb98f5d0011697b8a/16951116927618023368.png" />
            </div>
          </div>
          <div class="flex-col group_5 space-y-54">
            <div class="flex-col space-y-14">
              <div class="flex-row justify-between items-baseline">
                <span class="font_1">位置点</span>
                <span class="font_2 text_5">全选</span>
              </div>
              <div class="flex-row justify-between" :style="{ fontSize: '14px' }">
                <van-checkbox-group v-model="checkboxValue" shape="square" :style="{display: 'flex',flexWrap: 'wrap',width: '100%',justifyContent: 'space-between'}">
                  <van-checkbox @click="handleBoxChange(item.index)" style="width:30%; margin-bottom: 10px;" v-for="item in preset" :key="item.name" :name="item.index" :disabled="!item.inUse">{{item.label}}</van-checkbox>
                  <van-checkbox name="none" :disabled="true" style="opacity: 0; width:30%;margin-bottom: 10px;">占位</van-checkbox>
                </van-checkbox-group>
              </div>
              <div class="flex-row justify-between items-center">
                <span class="font_1 text_6">重置选择</span>
                <div class="flex-col justify-start items-center radio text-wrapper">
                  <span class="font_1 text_7">退出设置</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <van-popup v-model="showTime" position="bottom" :style="{ padding: '18px 12px', boxSizing: 'border-box'}">
      <van-picker v-model="currentTime" title="选择时间" show-toolbar :columns="columns" @confirm="handleTimeConfirm" />
    </van-popup>

  </div>
</template>

<script>
import moment from 'moment'

let index = 0

export default {
  data () {
    return {
      // acSwitch: false,
      preset: [1, 2, 3, 4, 5, 6, 7, 8],
      checkboxValue: [],
      channelNo: null,
      no: null,
      ysNo: null,
      showTime: false,
      columns: ["00:00", "01:00", "02:00", "03:00", "04:00", "05:00", "06:00", "07:00", "08:00", "09:00", "10:00", "11:00", "12:00", "13:00", "14:00", "15:00", "16:00", "17:00", "18:00", "19:00", "20:00", "21:00", "22:00", "23:00"],
      currentTime: "00:00",
      taskData: {}
    }
  },

  created () {
    const query = this.$route.query
    const { channelNo, no, ysNo } = query
    this.channelNo = channelNo
    this.no = no
    this.ysNo = ysNo
    // 获取预设点
    // 写死的8个预设点 有哪些点是已经设置了的
    this.initPoint(this.preset)
  },

  async mounted () {
    await this.getPoint()
    this.ysVideoTaskList()
  },

  methods: {
    initPoint (preset) {
      this.preset = preset.map(o => {
        return {
          label: `位置${o}`,
          name: o,
          index: o,
          inUse: false,
          active: false
        }
      })
    },


    // 获取预置点
    async getPoint () {
      await this.$api.rootMonitor_getPoint({
        ysNo: this.ysNo,
        channelNo: this.channelNo
      }).then(res => {
        const { errcode } = res
        if (errcode === 0) {
          let preset = res.preset?.length ? res.preset : []
          if (!preset.length) return
          preset.map((o, i) => {

            const findIndex = this.preset.findIndex(io => io.name == o.presetName)
            if (findIndex > -1) {
              this.preset[findIndex].inUse = true
            }
          })

          console.log("this.preset: ", preset, this.preset);


        }
      })
    },

    // 查询任务列表
    async ysVideoTaskList () {
      await this.$api.ysVideoTaskList(this.no).then(res => {
        if (res.errcode === 0) {
          const data = res.data
          if (data.prePos) {
            data.prePos = JSON.parse(data.prePos)
          }

          this.currentTime = data.timePoint
          this.checkboxValue = data.prePos
          this.oldCheckboxValue = [...data.prePos]
          this.taskData = { ...data }
        }
      })
    },


    // 选择时间
    handleTimeConfirm (value) {
      console.log("value:", value);
      this.showTime = false
      this.currentTime = value
      this.handleBoxChange(null)
    },

    async handleBoxChange (presetIndex) {
      let prePos = [...this.oldCheckboxValue]
      // 看当前是开的还是关的
      if (presetIndex) {
        if (this.oldCheckboxValue.includes(presetIndex)) {
          // 是取消
          prePos = this.oldCheckboxValue.filter(o => o != presetIndex)
        } else {
          // 是勾选
          prePos.push(...this.oldCheckboxValue, presetIndex)
        }
      }

      console.log("prePos:", prePos);

      await this.$toast.loading({
        message: "数据加载中...",
        forbidClick: true,
        duration: 0,
      });
      await this.$api.ysVideoSaveCaptureTask({
        gatewayNo: this.no,
        prePos: [...prePos],
        nextStartTime: moment(new Date()).format("YYYY-MM-DD ") + this.currentTime + ":00",
        status: 1
      }).then(res => {
        if (res.errcode == 0) {
          this.checkboxValue = [...prePos]
          this.ysVideoTaskList()
        } else {
          this.checkboxValue = [...this.oldCheckboxValue]
          this.$toast({
            message: `更新任务异常:${res.errmsg}`
          })
        }

        this.$toast.clear()
      }).catch(() => {
        this.checkboxValue = [...this.oldCheckboxValue]
        this.$toast.clear()
      })
    },

    // 更新拍照任务
    updateTask () {

    }
  }
}
</script>



<style lang="scss"  scoped>
@import "./../codeFunCommon.scss";
.page {
  background-color: #ffffff;
  width: 100%;
  overflow-y: auto;
  overflow-x: hidden;
  height: 100%;
}
.header {
  padding: 18px 10px 6px;
  background-color: #ededed;
  height: 89px;
}
.space-y-22 > *:not(:first-child) {
  margin-top: 22px;
}
.group {
  padding-left: 22px;
  padding-right: 4px;
}
.text {
  color: #333333;
  font-size: 15px;
  font-family: SF Pro Text;
  font-weight: 600;
  line-height: 11px;
}
.space-x-6 > *:not(:first-child) {
  margin-left: 6px;
}
.image {
  width: 17px;
  height: 11px;
}
.image_2 {
  width: 15px;
  height: 10.5px;
}
.image_3 {
  width: 24px;
  height: 11.5px;
}
.group_2 {
  padding: 8px 0;
}
.image_4 {
  width: 32px;
  height: 32px;
}
.pos {
  position: absolute;
  left: 0;
  top: 50%;
  transform: translateY(-50%);
}
.text_2 {
  color: #333333;
  font-size: 18px;
  font-family: PingFang SC;
  font-weight: 700;
  line-height: 17px;
  letter-spacing: 2px;
}
.group_3 {
  padding-top: 14px;
  overflow-y: auto;
}
.space-y-300 > *:not(:first-child) {
  margin-top: 300px;
}
.space-y-14 > *:not(:first-child) {
  margin-top: 14px;
}
.group_4 {
  padding: 0 10px;
}
.space-x-8 > *:not(:first-child) {
  margin-left: 8px;
}
.section {
  background-image: linear-gradient(180deg, #56a0fb 0%, #3776f6 100%);
  border-radius: 20px;
  width: 4px;
  height: 15px;
}
.text_3 {
  color: #333333;
  font-size: 16px;
  font-family: Source Han Sans SC;
  line-height: 15px;
}

.section_2 {
  margin: 0 20px;
  padding: 16px 4px 16px 12px;
  background-color: #f8f8f8;
  border-radius: 6px;
}
.font_1 {
  font-size: 16px;
  font-family: PingFang SC;
  line-height: 15px;
  color: #3a4a6e;
}
.space-x-42 > *:not(:first-child) {
  margin-left: 42px;
}
.text_4 {
  color: #4778e7;
  font-size: 14px;
  font-family: PingFang SC;
  font-weight: 700;
  line-height: 10.5px;
}
.image_5 {
  width: 17px;
  height: 17px;
}
.group_5 {
  padding: 12px 18px 0 30px;
}
.space-y-54 > *:not(:first-child) {
  margin-top: 54px;
}
.font_2 {
  font-size: 14px;
  font-family: PingFang SC;
  line-height: 13px;
  color: #333333;
}
.text_5 {
  color: #4778e7;
}

.image_6 {
  border-radius: 6px;
  width: 24px;
  height: 24px;
}
.section_3 {
  border-radius: 6px;
  width: 25px;
  height: 25px;
  border: dotted 1px #4778e7;
}
.radio {
  margin-right: 12px;
}
.checkbox {
  margin-left: 44px;
}
.text_6 {
  color: #4778e7;
  line-height: 14.5px;
}
.text-wrapper {
  padding: 16px 0;
  background-image: url("https://codefun-proj-user-res-1256085488.cos.ap-guangzhou.myqcloud.com/64489f9d5a7e3f0310f71776/6461034fb98f5d0011697b8a/16951116927708901897.png");
  background-size: 100% 100%;
  background-repeat: no-repeat;
  width: 167px;
  height: 47px;
}
.text_7 {
  color: #ffffff;
  line-height: 14.5px;
}

::v-deep .van-icon {
  // border-radius: unset;
  border-radius: 6px;
}

::v-deep .van-switch__node {
  top: -1px;
}
</style>
